// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"3653ac56","129":"888a2093","178":"f87408a2","257":"357e2f0c","325":"269aef9a","412":"ae9b0053","453":"ec0cf162","471":"636396cc","547":"6d5b96d2"}[chunkId] + ".chunk.js";
};